import React from 'react';
import { Badge } from './ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';
import { format } from 'date-fns';

export const UserStatus = ({ user, showLabel = true, size = 'md' }) => {
  const getStatusConfig = () => {
    if (user.status === 'on_leave') {
      return {
        color: 'bg-rose-500',
        label: 'On Leave',
        badgeClass: 'bg-rose-100 text-rose-700 border-rose-200'
      };
    } else if (user.status === 'active') {
      return {
        color: 'bg-emerald-500',
        label: 'Active',
        badgeClass: 'bg-emerald-100 text-emerald-700 border-emerald-200'
      };
    } else {
      return {
        color: 'bg-orange-500',
        label: 'Offline',
        badgeClass: 'bg-orange-100 text-orange-700 border-orange-200'
      };
    }
  };

  const config = getStatusConfig();
  const dotSize = size === 'sm' ? 'w-2 h-2' : size === 'lg' ? 'w-4 h-4' : 'w-3 h-3';

  const tooltipContent = () => {
    if (user.status === 'on_leave' && user.leave_start && user.leave_end) {
      return `On leave from ${format(new Date(user.leave_start), 'MMM dd')} to ${format(new Date(user.leave_end), 'MMM dd')}`;
    } else if (user.status === 'active' && user.last_active) {
      return `Active - Last seen ${format(new Date(user.last_active), 'MMM dd, HH:mm')}`;
    } else {
      return config.label;
    }
  };

  if (!showLabel) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className={`${dotSize} ${config.color} rounded-full`} data-testid={`user-status-${user.user_id}`} />
          </TooltipTrigger>
          <TooltipContent>
            <p>{tooltipContent()}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <Badge className={`${config.badgeClass} border text-xs`} data-testid={`user-status-badge-${user.user_id}`}>
      <div className={`${dotSize} ${config.color} rounded-full mr-1.5`} />
      {config.label}
    </Badge>
  );
};
